import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/hooks/useTheme';
import { useTranslation } from 'react-i18next';
import { AnimatedSwitch } from './animated-switch';

export const ThemeToggle = () => {
  const { toggleTheme, isDark } = useTheme();
  const { t } = useTranslation();

  return (
    <button
      onClick={toggleTheme}
      className="w-full flex items-center gap-3 px-3 py-2 bg-transparent transition-colors text-sm"
    >
      <motion.div
        initial={false}
        animate={{ rotate: isDark ? 180 : 0 }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
        className="relative"
      >
        {isDark ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
      </motion.div>

      <span className="font-medium">
        {isDark ? t('theme.dark_mode') : t('theme.light_mode')}
      </span>

      <div className="ml-auto">
        <AnimatedSwitch checked={isDark} onChange={toggleTheme} />
      </div>
    </button>
  );
};
